import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import History from "@/components/History";
import Leadership from "@/components/Leadership";
import Schedule from "@/components/Schedule";
import Gallery from "@/components/Gallery";
import Donations from "@/components/Donations";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <History />
      <Leadership />
      <Schedule />
      <Gallery />
      <Donations />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
